<ng-container *ngIf="type() && control && formType() === 'text-input'">
  <mat-form-field class="{{ additionalClass() }}">
    <mat-label  [ngClass]="{
      'text-red': control.invalid && (control.dirty || control.touched)
    }">{{ label() }}</mat-label>
    
     <input
      matInput
      [type]="type() === 'password' && hide ? 'password' : 'text'"
      [autocomplete]="autocomplete()"
      [value]="value" 
      [formControl]="control"
      [mask]="maskComputed()"
      [thousandSeparator]="type() === 'money' ? ',' : ''"
      [prefix]="type() == 'money' ? (prefix() ?? prefixComputed() ?? '') : ''"
      [attr.disabled]="disabled"
      [step]="stepComputed()"
      [min]="minComputed()"
      [max]="max()"
      [dropSpecialCharacters]="specialCharaters() || false"
      [pattern]="patternComputed()"
      [readonly]="readonly()"
      [placeholder]="placeholder()"
      [ngClass]="{
        'text-center': alignment() === 'center',
        'text-left': alignment() === 'left',
        'text-right': alignment() === 'right'
      }"
    />
  
    <mat-hint align="start" *ngIf="startHint()"
      ><strong>{{ startHint() }}</strong></mat-hint
      >
      <mat-hint align="end" *ngIf="endHint()"
      ><strong>{{ endHint() }}</strong></mat-hint
      >


    <button matSuffix *ngIf="suffix()" type="button" class="showpassword" (click)="showPasswordHandler()">
      <lib-icon matSuffix  [icon]="suffix() ?? ''"></lib-icon>
    </button>

    <mat-error *ngIf="showError && control?.hasError('required')" [id]="''">Required</mat-error>
    <mat-error *ngIf="control?.hasError('email')" [id]="''">Must be a valid email</mat-error>
    <mat-error *ngIf="control?.hasError('pattern')">{{ patternErrorMessageComputed() }}</mat-error>
    
    <mat-error *ngIf="control?.hasError('min')" [id]="''">{{ minError() }}</mat-error>
    <mat-error *ngIf="control?.hasError('max')" [id]="''">{{ maxError() }}</mat-error>
    <mat-error *ngIf="control?.hasError('minlength')" [id]="''">Min {{ control.getError('minlength')?.requiredLength || '' }} Characters</mat-error>
    <mat-error *ngIf="control?.hasError('maxlength')" [id]="''">Max {{ control.getError('maxlength')?.requiredLength }} Characters</mat-error>
    <mat-error *ngIf="control?.hasError('message')" [id]="''">{{ control.getError('message') }}</mat-error>
    <mat-error *ngIf="control?.hasError('equalTo')" [id]="''">Passwords do not match</mat-error>
  </mat-form-field>
</ng-container>


<ng-container *ngIf="type() && control && formType() === 'search-input'">
     <input
      [type]="type() === 'password' && hide ? 'password' : 'text'"
      [autocomplete]="autocomplete()"
      [value]="value" 
      [formControl]="control"
      [mask]="maskComputed()"
      [thousandSeparator]="type() === 'money' ? ',' : ''"
      [prefix]="type() == 'money' ? (prefix() ?? prefixComputed() ?? '') : ''"
      [attr.disabled]="disabled"
      [step]="stepComputed()"
      [min]="minComputed()"
      [max]="max()"
      [dropSpecialCharacters]="specialCharaters() || false"
      [pattern]="patternComputed()"
      [readonly]="readonly()"
      [placeholder]="placeholder()"
      [ngClass]="{
        'text-center': alignment() === 'center',
        'text-left': alignment() === 'left',
        'text-right': alignment() === 'right'
      }"
    />
  
    <mat-hint align="start" *ngIf="startHint()"
      ><strong>{{ startHint() }}</strong></mat-hint
      >
      <mat-hint align="end" *ngIf="endHint()"
      ><strong>{{ endHint() }}</strong></mat-hint
      >

    <button matSuffix *ngIf="suffix()" type="button" class="showpassword" (click)="showPasswordHandler()">
      <lib-icon matSuffix  [icon]="suffix() ?? ''"></lib-icon>
    </button>
</ng-container>